// EditCustomerDialog.js
import React, { useState, useEffect } from 'react';
import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  Button, TextField, Box, Grid
} from '@mui/material';
import { authFetchRequest } from './utils/api';
import { alertC } from './components/dialogService';

const EditCustomerDialog = ({ open, onClose, customer, onCustomerUpdated }) => {
  const [formData, setFormData] = useState({
    name: '', email: '', phone: '', discount: '0', products: '',
    netTerms: '', fullName: '', mobilePhone: '', address1: '',
    address2: '', city: '', province: '', country: '', postalCode: ''
  });

  useEffect(() => {
    if (customer) {
      setFormData({
        name: customer.name || '',
        email: customer.email || '',
        phone: customer.phone || '',
        discount: customer.discount || '0',
        products: customer.products || '',
        netTerms: customer.netTerms || '',
        fullName: customer.fullName || '',
        mobilePhone: customer.mobilePhone || '',
        address1: customer.address1 || '',
        address2: customer.address2 || '',
        city: customer.city || '',
        province: customer.province || '',
        country: customer.country || '',
        postalCode: customer.postalCode || ''
      });
    }
  }, [customer]);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSave = async () => {
    try {
      const payload = {
        ...formData,
        fkUserId: customer.fkUserId  // keep original owner
      };

      const updated = await authFetchRequest(
        `/customers/${customer.id}`,
        payload,
        "PUT"
      );

      onCustomerUpdated(updated);
      onClose();
      await alertC("Customer updated successfully!");
    } catch (err) {
      console.error("Failed to update customer:", err);
      await alertC("Failed to update customer: " + (err.message || "Unknown error"));
    }
  };

  if (!customer) return null;

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>Edit Customer: {customer.name}</DialogTitle>
      <DialogContent>
        <Box sx={{ pt: 1 }}>
          <Grid container spacing={2}>
            {Object.keys(formData).map((key) => (
              <Grid item xs={12} sm={6} key={key}>
                <TextField
                  label={key.charAt(0).toUpperCase() + key.slice(1).replace(/([A-Z])/g, ' $1')}
                  name={key}
                  value={formData[key]}
                  onChange={handleChange}
                  fullWidth
                  size="small"
                />
              </Grid>
            ))}
          </Grid>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button onClick={handleSave} variant="contained" color="primary">
          Save Changes
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default EditCustomerDialog;